//logistics/frontend/src/components/OrdersPage/OrderDocumentsPage/UploadDocumentModal.jsx

import React, { useState } from "react";
import axios from "axios";


const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

export default function UploadDocumentModal({ orderId, onClose, onSuccess }) {
  const [file, setFile] = useState(null);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("comment", comment);
    formData.append("order", orderId); // если у тебя есть связь с заказом

    try {
      setLoading(true);

      await axios.post(`${BASE_URL}/api/documents/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      onSuccess?.();
      onClose();
    } catch (err) {
      console.error("Upload error:", err);
      alert("Ошибка загрузки");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white w-[400px] p-4 rounded shadow-lg space-y-3">

        <h2 className="text-lg font-bold">Загрузить документ</h2>

        <input
          type="file"
          onChange={(e) => setFile(e.target.files[0])}
        />

        <textarea
          placeholder="Комментарий"
          className="w-full border p-2"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />

        <div className="flex justify-end space-x-2">
          <button onClick={onClose} className="px-3 py-1 border">
            Отмена
          </button>

          <button
            onClick={handleUpload}
            disabled={loading}
            className="px-3 py-1 bg-blue-600 text-white"
          >
            {loading ? "Загрузка..." : "Сохранить"}
          </button>
        </div>

      </div>
    </div>
  );
}